import type { getYourTeamBCQuery } from '../../__generated__/graphql';
import type { BridgeTeamPAAgent } from '../../fixtures/bridgeContainer';

export const usePrepareYourTeamData = (
    data?: getYourTeamBCQuery | undefined
): { userFirstName: string | null; paAgent: BridgeTeamPAAgent | null } => {
    if (!data) {
        return {
            userFirstName: null,
            paAgent: null,
        };
    }

    return {
        userFirstName: data.viewer?.firstName ?? null,
        paAgent:
            data.bridgeContainer?.moves[0]?.team.agents.find(({ paAgent }) => !!paAgent)?.paAgent ??
            null,
    };
};
